import { FC } from 'react'
import { Select } from 'antd'
import { CheckBoxLabel } from '@UI/CheckBox'
import InfoComp from '@pages/Admin/CRMSettings/components/InfoComp/InfoComp'
import CreateLinkNumberInput from '../../../../../CreateLinkNumberInput'
import type { MonthlyCourseLinkPeriodUnit } from '../../../../../monthlyCourseLinkDiscount.utils'
import StreamSelectTariffValueField from '../../../../StreamCustomPeriodLinkFields/StreamSelectTariffValueField'
import classes from '../index.module.css'
import spclasses from '../../../../../../SetCourseClassDirectionModal/purchase.module.css'
import { CREATE_LINK_BLOCK_TARIFF_TYPES } from '../../../../../tariffTypes'
import { withCreateLinkBlockTariffTypesHint } from '../../../../../createLinkBlockInfoContent'

export type StreamAdditionalCoursePeriodFieldsProps = {
  isPeriodFixed: boolean
  periodUnit: MonthlyCourseLinkPeriodUnit
  periodValue: number | null
  tariff: ICourseTariff
  onTogglePeriodFixed: (checked?: boolean) => void
  onChangePeriodUnit: (value: MonthlyCourseLinkPeriodUnit) => void
  onChangeValue: (value: string | number | null) => void
  onChangeUnfixedValue: (value: number) => void
}

/**
 * Фиксация периода доп. курса stream_*:
 * — выкл: SelectTariffValue по настройкам тарифа;
 * — вкл: period_unit + value.
 */
const StreamAdditionalCoursePeriodFields: FC<
  StreamAdditionalCoursePeriodFieldsProps
> = ({
  isPeriodFixed,
  periodUnit,
  periodValue,
  tariff,
  onTogglePeriodFixed,
  onChangePeriodUnit,
  onChangeValue,
  onChangeUnfixedValue,
}) => {
  return (
    <div className={classes.monthlyFields}>
      <div className={spclasses.inputWithLabel}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CheckBoxLabel
            type="button"
            value={isPeriodFixed}
            onClick={onTogglePeriodFixed}
            label="Зафиксировать период оплаты"
            className={spclasses.checkboxWithLabel}
            style={{
              justifyContent: 'flex-start',
              paddingTop: '4px',
              paddingBottom: '4px',
              height: 'auto',
            }}
          />
          <InfoComp
            text={withCreateLinkBlockTariffTypesHint(
              'По умолчанию клиент при покупке сам выбирает, на какой период ему оплатить обучение. При включении данного чекбокса вы фиксируете период оплаты.',
              CREATE_LINK_BLOCK_TARIFF_TYPES.streamCustomPeriod,
            )}
          />
        </div>
      </div>

      {isPeriodFixed ? (
        <div className={classes.monthlyFieldsRow}>
          <div className={spclasses.inputWithLabel}>
            <div className={spclasses.inputLabel}>Единица периода</div>
            <Select
              className={spclasses.selectField}
              popupClassName={spclasses.selectFieldPopup}
              value={periodUnit}
              options={[
                { value: 'month', label: 'Месяцы' },
                { value: 'day', label: 'Дни' },
              ]}
              onChange={onChangePeriodUnit}
            />
          </div>
          <div className={spclasses.inputWithLabel}>
            <CreateLinkNumberInput
              className={spclasses.input}
              title={
                periodUnit === 'day' ? 'Количество дней' : 'Количество месяцев'
              }
              integer
              min={1}
              value={periodValue}
              onChange={onChangeValue}
            />
          </div>
        </div>
      ) : (
        <div style={{ paddingLeft: '8px', paddingTop: '4px' }}>
          <StreamSelectTariffValueField
            tariff={tariff}
            value={periodValue ?? undefined}
            onChange={onChangeUnfixedValue}
          />
        </div>
      )}
    </div>
  )
}

export default StreamAdditionalCoursePeriodFields
